import { PropsWithChildren } from "react";

import { RouteContext, RouteProps } from "@/contexts/RouteContext";

type RouteProviderProps = PropsWithChildren<RouteProps>;

export function RouteProvider({ children, ...routeProps }: RouteProviderProps) {
  return <RouteContext.Provider value={routeProps}>{children}</RouteContext.Provider>;
}
